import { animate, style, transition, trigger } from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, inject, OnDestroy, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { SegmentImage } from '@banyan/commons/enum/segment-image';
import { Segment } from '@banyan/commons/models/segment.model';
import { CaptureNeedService } from '@banyan/modules/capture-needs/services/capture-need.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-home-hero',
  templateUrl: './home-hero.component.html',
  styleUrls: ['./home-hero.component.scss'],
  animations: [
    trigger('imageFade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('300ms ease', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class HomeHeroComponent implements  OnDestroy {
  notifier = new Subject<void>();
  captureNeedService = inject(CaptureNeedService);
  segmentStatic: Segment[] = [
    {
      id: 5,
      code: 'air_freshener',
      name: 'Air Freshener',
      icon: 'diffusor',
      hasTargetMarket: true,
      categories: [],
    },
    {
      id: 6,
      code: 'oral_care',
      name: 'Oral Care',
      icon: 'coloration',
      hasTargetMarket: true,
      categories: [],
    },
  ];
  isVisible: boolean = true;

  constructor(private readonly router: Router,
              @Inject(PLATFORM_ID) private readonly platformId: any,
              private readonly cdr: ChangeDetectorRef) {}

  handleSelectedSegment(segment: Segment) {
    this.captureNeedService.needCapture.productUse.selectedSegment.set(segment);
    this.onSegmentChange();
    if (segment.code === 'oral_care') {
      this.router.navigate(['/edito/oral-care']).then();
    }
  }

  onSegmentChange() {
    this.isVisible = false;
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.isVisible = true;
        this.cdr.detectChanges();
      }, 300);
    }
  }

  getSegmentName(segment: Segment | null): string {
    return this.captureNeedService.needCapture.productUse.segments().length
      ? SegmentImage[segment?.code as keyof typeof SegmentImage]
      : 'personal_care';
  }

  ngOnDestroy(): void {
    this.notifier.complete();
  }
}
